import type { FC } from "react";
import { Content } from "src/shared/components/content";
import { dayContextTagRecipe } from "./day-context-tag.recipe";

interface Props {
  day: "today" | "tomorrow";
  device: "desktop" | "mobile";
}

/**
 * Contextual time badge for performer event grid list items.
 *
 * - Desktop: folder-tab positioned absolutely at the top-right corner of the card.
 * - Mobile: inline pill rendered above the event title in the body column.
 *
 * Today = brand purple, Tomorrow = near-black. Both variants include a white dot prefix.
 */
export const DayContextTag: FC<Props> = ({ day, device }) => {
  const { root, dot, label: labelClass } = dayContextTagRecipe({ day, device });
  return (
    <div className={root}>
      <span className={dot} />
      <span className={labelClass}>
        {/* Today | Tomorrow */}
        <Content id={day === "today" ? "cid$#4099715#" : "cid$#4099716#"} />
      </span>
    </div>
  );
};
